export default __webpack_public_path__ + "static/media/a_03.1cb93850.jpg";